import { forwardRef } from "react";
import styles from "./dialog.module.css";

// Footer buttons for <Dialog>. variant: "primary" (the action) · "secondary"
// (cancel / close) · "danger" (an action that removes something). `form`: the
// id of a <form> in the body this button submits (type="submit").
const DialogButton = forwardRef(
  (
    {
      variant = "secondary",
      onClick,
      disabled = false,
      type = "button",
      form,
      children,
    },
    ref,
  ) => (
    <button
      ref={ref}
      type={type}
      form={form}
      className={`${styles.button} ${styles[variant] || styles.secondary}`}
      onClick={onClick}
      disabled={disabled}
    >
      {children}
    </button>
  ),
);

DialogButton.displayName = "DialogButton";

export default DialogButton;
